"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageLevelMessage_1 = require("./PageLevelMessage");
exports.default = PageLevelMessage_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelMessage/index.js
// module id = 653
// module chunks = 8